// extracted by mini-css-extract-plugin
export default {"switcher":"rrY1kR"};